import {
  Control,
  Controller,
  FieldErrors,
  UseFormClearErrors,
  UseFormSetValue,
  UseFormTrigger,
  UseFormWatch,
} from 'react-hook-form';
import SharedTransferList from '../../../../shared/shared-transfer-list';
import { RulesEngineFormValues } from '../rules-engine-form-page-old';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
interface StepSourcesProps {
  control: Control<RulesEngineFormValues>;
  setValue: UseFormSetValue<RulesEngineFormValues>;
  watch: UseFormWatch<RulesEngineFormValues>;
  errors: FieldErrors<RulesEngineFormValues>;
  trigger: UseFormTrigger<RulesEngineFormValues>;
  clearErrors: UseFormClearErrors<RulesEngineFormValues>;
}

export default function CalendarResourcesStep({
  control,
  setValue,
  watch,
  errors,
  trigger,
  clearErrors,
}: StepSourcesProps) {
  const sources = watch('triggerInfo.triggerCalendarSources') || [];
  const allSource = watch('allSource');
  function addSelection(emails: string[]) {
    const uniqueEmails = Array.from(new Set([...sources, ...emails]));
    setValue('triggerInfo.triggerCalendarSources', uniqueEmails);

    clearErrors('triggerInfo.triggerCalendarSources');
    if (uniqueEmails.length === 0) {
      trigger('triggerInfo.triggerCalendarSources');
    }
  }

  function removeSelection(emails: string[]) {
    const newList = sources.filter((userEmail) => !emails.includes(userEmail));
    setValue('triggerInfo.triggerCalendarSources', newList);
  }

  const handleAddAllChecked = (value: boolean) => {
    setValue('allSource', value);
    if (value) {
      setValue('triggerInfo.triggerCalendarSources', []);
      clearErrors('triggerInfo.triggerCalendarSources');
    }
  };

  return (
    <Box
      sx={{
        viewTransitionName: 'steps',
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Stack gap={2} sx={{ flexShrink: 0, height: '100%' }}>
        <Stack
          flexDirection={'row'}
          gap={4}
          alignItems={'center'}
          justifyContent="center"
        >
          <Controller
            name={'triggerInfo'}
            control={control}
            render={() => {
              return (
                <FormControl>
                  <FormLabel>Calendar Resource</FormLabel>
                </FormControl>
              );
            }}
          />
        </Stack>
        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            width: '100%',
          }}
        >
          <Controller
            name={'triggerInfo.triggerCalendarSources'}
            control={control}
            render={() => (
              <SharedTransferList
                sources={sources}
                addSelection={addSelection}
                removeSelection={removeSelection}
                handleAddAllChecked={handleAddAllChecked}
                errors={!!errors.triggerInfo?.triggerCalendarSources}
                helperText={
                  errors?.triggerInfo?.triggerCalendarSources?.message || ' '
                }
                allSource={allSource}
                domains={[]}
                sourceType={'Resource_Calendar'}
                hasSelectAllOption={true}
                roles={[]}
              />
            )}
          />
        </Box>
      </Stack>
    </Box>
  );
}
